import { render } from "./TheSidebar.vue?vue&type=template&id=1a900c24&scoped=true&ts=true"
import script from "./TheSidebar.vue?vue&type=script&lang=ts"
export * from "./TheSidebar.vue?vue&type=script&lang=ts"

import "./TheSidebar.vue?vue&type=style&index=0&id=1a900c24&scoped=true&lang=scss"

import exportComponent from "/Users/damiandudek/Desktop/PRACA/git/114.TGA-mobile-git/tga-mobile/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a900c24"]])

export default __exports__